import { CarrierDocsResponse } from '../types';

interface getAPISpectResult extends CarrierDocsResponse {
  openapi: '3.1.0';
}

export function getAPISpec(res: CarrierDocsResponse): getAPISpectResult {
  const paths = res[2].paths.reduce((acc, path) => {
    const obj = Object.entries(path).reduce((acc, [key, val]) => {
      acc[key] = val;
      return acc;
    }, {});

    return { ...acc, ...obj };
  }, {});

  return {
    openapi: '3.1.0',
    ...res[0],
    ...res[1],
    paths,
  };
}
